'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var compareVersions = require('compare-versions');

var version = '';
function setVersion(v) {
  version = v;
}
function getVersion() {
  return version;
}
function compareWithInstanceVersion(v, operator) {
  return compareVersions.compare(version, v, operator);
}

exports.compareWithInstanceVersion = compareWithInstanceVersion;
exports.getVersion = getVersion;
exports.setVersion = setVersion;
